<template>
  <div class="pull-refresh-container center-container-wrap">
    <div class="section-container">
      <el-row :gutter="20">
        <el-col
          :span="8"
          class="wow animate__slideInUp"
          v-for="item in list"
          :key="item.id"
        >
          <div class="item-wrap" @click="goPage(item)">
            <div class="img-box">
              <img class="img-responsive" :src="item.cover" />
            </div>
            <div class="info-box">
              <p class="label">{{ item.type }}</p>
              <p class="title">{{ item.title }}</p>
              <p class="desc">{{ item.info }}</p>
              <p class="time">{{ item.time }}</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "PullRefresh",
  props: {
    list: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    goPage(item) {
      const routeUrl = this.$router.resolve({
        name: "NewsDetail",
        params: {
          id: item.id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.pull-refresh-container {
  width: 100%;
  .item-wrap {
    margin-top: 20px;
    height: 311px;
    cursor: pointer;
    border: 1px solid #dbdbdb;
    overflow: hidden;
    position: relative;
  }

  .img-box {
    overflow: hidden;
    position: relative;
    cursor: pointer;
    height: 198px;
    > img {
      transition: all ease-in-out 0.2s 0s;
      top: 50%;
      width: 100%;
      left: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      display: block;
      max-width: 100%;
      height: auto;
    }
  }

  .info-box {
    position: absolute;
    width: 100%;
    height: 110px;
    overflow: hidden;
    background-color: #ffffff;
    bottom: 0;
    border-top: 1px solid #f5f5f5;
    transition: all ease-in-out 0.2s 0s;
    box-sizing: border-box;
    padding: 0 15px;

    .label {
      color: #008048;
      margin-top: 6px;
      font-size: 13px;
    }

    .title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      color: #565c61;
      font-size: 16px;
      margin-top: 10px;
    }

    .desc {
      position: absolute;
      top: 60%;
      text-align: justify !important;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      opacity: 0;
      color: #7a7a7a;
      font-size: 13px;
      height: 38px;
      white-space: pre-wrap;
    }

    .time {
      position: absolute;
      color: #7a7a7a;
      font-size: 11px;
      margin-top: 5px;
      bottom: 8px;
    }
  }

  .item-wrap:hover {
    .info-box {
      height: 155px;
    }

    .desc {
      opacity: 1;
    }
  }
}
</style>
